module.exports = __webpack_public_path__ + "img/1.6b23c244.png";